module.exports = __webpack_public_path__ + "img/bnaner3-home.af5b51d0.png";